import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTrafficManagement = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M19.5 13.52V4.28571C19.5 1.91878 17.5381 0 15.1181 0H4.88192C2.46185 0 0.5 1.91878 0.5 4.28571V16.3314C0.5 18.3575 2.17935 20 4.25092 20H18.6236C19.1076 20 19.5 19.6162 19.5 19.1429C19.5 18.6695 19.1076 18.2857 18.6236 18.2857H4.25092C3.14737 18.2857 2.25277 17.4108 2.25277 16.3314C2.25277 15.2521 3.14737 14.3771 4.25092 14.3771H18.6236C19.1076 14.3771 19.5 13.9934 19.5 13.52ZM15.7452 6.8865L12.7572 9.9718C12.6158 10.1175 12.4221 10.2002 12.2194 10.2014C12.0292 10.2008 11.8469 10.1256 11.7114 9.99177L10.1577 8.51402C9.93356 8.22556 9.94998 7.817 10.1966 7.54756C10.4431 7.27812 10.8477 7.2266 11.1537 7.42567L12.1497 8.42415L14.6496 5.85806C14.9381 5.64723 15.3351 5.67055 15.5971 5.91374C15.8591 6.15692 15.9128 6.55196 15.7252 6.85654L15.7452 6.8865ZM4.75 15.6001C4.33579 15.6001 4 15.9359 4 16.3501C4 16.7643 4.33579 17.1001 4.75 17.1001H18.25C18.6642 17.1001 19 16.7643 19 16.3501C19 15.9359 18.6642 15.6001 18.25 15.6001H4.75Z",
		fill: "currentColor"
	})
});
export default SvgTrafficManagement;
